var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-open-positions-block" },
    [
      _c(
        "Row",
        [
          _c(
            "Column",
            { attrs: { md: 12 } },
            [
              _vm.title
                ? _c(
                    "Heading",
                    {
                      staticClass: "u-add-colored-period",
                      attrs: { noMarginTop: "" },
                    },
                    [_vm._v(_vm._s(_vm.title))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.intro
                ? _c("p", { staticClass: "c-open-positions-block__intro" }, [
                    _vm._v(_vm._s(_vm.intro)),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Row",
        { staticClass: "c-open-positions-block__categories" },
        [
          _c(
            "Column",
            { attrs: { xs: 11, sm: 5, md: 5 } },
            [
              _c("Dropdown", {
                attrs: { options: _vm.countryList, placeholder: "Company" },
                on: { input: _vm.updateData },
                model: {
                  value: _vm.selectedCountry,
                  callback: function ($$v) {
                    _vm.selectedCountry = $$v
                  },
                  expression: "selectedCountry",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Column",
            { staticClass: "col-no-gutter", attrs: { xs: 1 } },
            [
              _vm.selectedCountry
                ? _c("Button", {
                    staticClass: "c-clear-button",
                    attrs: { buttonStyle: "no-style", icon: "cross" },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.reset("country")
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Column",
            { attrs: { xs: 11, sm: 5, md: 5 } },
            [
              _c("Dropdown", {
                attrs: {
                  options: _vm.filteredOfficeList,
                  placeholder: "Office",
                },
                on: { input: _vm.updateData },
                model: {
                  value: _vm.selectedOffice,
                  callback: function ($$v) {
                    _vm.selectedOffice = $$v
                  },
                  expression: "selectedOffice",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Column",
            { staticClass: "col-no-gutter", attrs: { xs: 1 } },
            [
              _vm.selectedOffice
                ? _c("Button", {
                    staticClass: "c-clear-button",
                    attrs: { buttonStyle: "no-style", icon: "cross" },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.reset("office")
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Row",
        { staticClass: "c-vacancy-table-header" },
        [
          _c(
            "Column",
            { attrs: { xs: 12, sm: 10 } },
            [
              _c(
                "Button",
                {
                  attrs: { buttonStyle: "no-style", icon: "toggle_sort" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.sortyByTitle()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.getLabel("vacancyPage", "jobTitleText")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Column",
            { attrs: { sm: 6 } },
            [
              _c(
                "Button",
                {
                  attrs: { buttonStyle: "no-style", icon: "toggle_sort" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.sortByCompany()
                    },
                  },
                },
                [_vm._v("\n                Company\n            ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Column",
            { attrs: { xs: 12, sm: 6 } },
            [
              _c(
                "Button",
                {
                  attrs: { buttonStyle: "no-style", icon: "toggle_sort" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.sortByLocation()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.getLabel("vacancyPage", "locationHeadingText")
                      ) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("List", {
        attrs: { items: _vm.vacancyList, disableUrl: "" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ item }) {
              return [
                _c(
                  "Row",
                  { staticClass: "c-open-positions-block__vacancy" },
                  [
                    _c(
                      "Column",
                      {
                        staticClass: "c-open-positions-block__vacancy__col1",
                        attrs: { sm: 10 },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "u-block u-display-sm-down c-open-positions-block__vacancy__country@sm",
                          },
                          [_vm._v(_vm._s(item.country))]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "u-block c-open-positions-block__vacancy__title",
                          },
                          [_vm._v(_vm._s(item.title))]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "Column",
                      { staticClass: "u-hidden-xs", attrs: { sm: 6 } },
                      [_c("span", [_vm._v(_vm._s(item.departmentLabel))])]
                    ),
                    _vm._v(" "),
                    _c(
                      "Column",
                      { staticClass: "u-display-md-up", attrs: { sm: 6 } },
                      [_c("span", [_vm._v(_vm._s(item.location.name))])]
                    ),
                    _vm._v(" "),
                    _c(
                      "Column",
                      { staticClass: "text-right", attrs: { sm: 2 } },
                      [
                        _c(
                          "Anchor",
                          {
                            attrs: {
                              isFancy: "",
                              href: _vm.detailedBaseUrl + "?id=" + item.id,
                            },
                          },
                          [_vm._v(_vm._s(_vm.getLabel("global", "readMore")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }